/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import { MedicActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const startInputMedicEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_MEDIC_START && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, action.post || {}, MedicActions.startedInputMedic))
);

export const fetchInputMedicStatusEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_MEDIC_STATUS && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        // INPUT_MEDIC_STATUS endpoint has both :id and :token — replace both
        // by passing token as a post-style param so api()'s :token swap applies.
        const post = action.token ? {token: action.token} : null;
        return api(action.type, state$, action.id, post, MedicActions.receiveInputMedicStatus);
    })
);

export const fetchInputMedicListEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_MEDIC_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, MedicActions.receiveInputMedicList))
);

export const startFeedMedicEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.FEED_MEDIC_START && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, MedicActions.startedFeedMedic))
);

export const fetchFeedMedicStatusEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.FEED_MEDIC_STATUS && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        const post = action.token ? {token: action.token} : null;
        return api(action.type, state$, null, post, MedicActions.receiveFeedMedicStatus);
    })
);

export const fetchFeedMedicShareEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.FEED_MEDIC_SHARE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, MedicActions.receiveFeedMedicShare))
);
